import User from '../models/User';
import apiClient from '../components/apiClient';

export class UserService {
    static getUser(firstName: string, lastName: string) : Promise<User> {
        return apiClient.get<User>(`/User/GetUser/${firstName}/${lastName}`).then(res => res.data);
    }
}